// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__OPhkD","modal_content":"Modal_modal_content__XR8lb","buttons":"Modal_buttons__A48xo","h3":"Modal_h3__O2Ybo","p":"Modal_p__FUMOy","close":"Modal_close__rwI5e"};